export { default, default as Animate } from './Animate'
export * as AnimateStyles from './styles/Animate.style'

export type { AnimateProps } from './Animate.types'
export type { StyledAnimateProps } from './styles/Animate.style.types'
export type { AnimationTypes } from './animations/animations.types'
